import React from 'react'
import PropTypes from 'prop-types'
import { useWillPipe } from '@morningtrain/react-helpers'
import useForm from '../hooks/use-form'

export default function SubmitFormOnPipe ({ formRef, data, mergeDataFromPayload }) {
  const form = useForm()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      let formToSubmit = null

      if (formRef && formRef.current && typeof formRef.current.submit === 'function') {
        /// Support resetting native forms
        formToSubmit = formRef.current
      } else if (form && typeof form.submit === 'function') {
        /// Handle resetting form providing through context
        formToSubmit = form
      }

      if (formToSubmit !== null) {
        let newData = { ...data }
        if (mergeDataFromPayload && payload.data && typeof (payload.data) === 'object') {
          newData = { ...(payload.data), ...newData }
        }

        Promise.resolve(formToSubmit.submit(newData))
          .then(() => {
            resolve(payload)
          })
          .catch(err => {
            reject(err)
          })
      } else {
        reject('Tried to submit form on pipe, but no form was found')
      }
    })
  })

  return null
}

SubmitFormOnPipe.defaultProps = {
  formRef: null,
  data: {},
  mergeDataFromPayload: false
}

SubmitFormOnPipe.propTypes = {
  formRef: PropTypes.object,
  data: PropTypes.object,
  mergeDataFromPayload: PropTypes.bool
}
